import { canvasDimension } from '@/constants/canvas';
import { ICanvasElement } from '@/interface/canvas';

export const BackgroundColorPreview = ({
  element,
}: BackgroundColorPreviewProps) => {
  return (
    <div
      className="selector"
      id={element.id}
      style={{
        position: 'absolute',
        backgroundColor: element?.background_color || '#000000',
        height: canvasDimension.HEIGHT,
        width: canvasDimension.WIDTH,
        top: 0,
        left: 0,
      }}
    />
  );
};
type BackgroundColorPreviewProps = {
  element: ICanvasElement;
};
export default BackgroundColorPreview;
